import React from "react";
import "./ExpertiseSelector.scss";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import { ProfileFormData } from "@features/settings/model/types";
import { useUnit } from "effector-react";
import { $expertiseTerms } from "@/core/store/terms";
import { Term } from "@/core/store/terms/types";
import { Control, Controller } from "react-hook-form";

interface ExpertiseSelectorProps {
  control: Control<ProfileFormData>;
}

export const ExpertiseSelector: React.FC<ExpertiseSelectorProps> = ({
  control,
}) => {
  const expertiseTerms = useUnit($expertiseTerms);

  return (
    <>
      <div className="form-row">
        <div className="form-group">
          <label>Fields of expertise (optional)</label>
          <Controller
            name="expertise"
            control={control}
            render={({ field }) => {
              const selectedExpertiseIds = field.value || [];

              const handleExpertiseChange = (
                expertiseId: number,
                checked: boolean,
              ) => {
                let newExpertiseIds: number[];

                if (checked) {
                  // Add expertise ID if checked
                  newExpertiseIds = [...selectedExpertiseIds, expertiseId];
                } else {
                  // Remove expertise ID if unchecked
                  newExpertiseIds = selectedExpertiseIds.filter(
                    (id: number) => id !== expertiseId,
                  );
                }

                field.onChange(newExpertiseIds);
              };

              return (
                <div className="expertise-options flex flex-column gap-3">
                  {expertiseTerms.data.map((term: Term) => {
                    const termId = parseInt(term.tid);
                    return (
                      <div key={term.tid} className="flex align-items-center">
                        <Checkbox
                          inputId={term.tid}
                          checked={selectedExpertiseIds.includes(termId)}
                          onChange={(e) =>
                            handleExpertiseChange(termId, e.checked || false)
                          }
                        />
                        <label htmlFor={term.tid} className="option-label">
                          {term.name}
                        </label>
                      </div>
                    );
                  })}
                </div>
              );
            }}
          />
        </div>
      </div>
      <Divider />
    </>
  );
};
